import { useState } from 'react';
import { uniqueFirstByTrimmedName } from '@/utils/uniqueByTrimmedName';
import { ExpandMoreIcon, ExpandLessIcon } from '@/components/ui/Icons';
import type { ProjectReader } from '@/api/client';
import { useAuth } from '@/contexts/useAuth';
import { ReadersDataTable } from './ReaderContractorCellTables';
import { ExpandableVerticalSlice } from './ExpandableVerticalSlice';

interface ReadersCellProps {
  readers: ProjectReader[];
  compact?: boolean;
  searchHighlightWords?: string[];
}

export function ReadersCell({ readers, compact, searchHighlightWords }: ReadersCellProps) {
  const { capabilities } = useAuth();
  const hidePrices = !capabilities.prices;
  const [expanded, setExpanded] = useState(false);

  if (!readers?.length) return <span className="projects-table__empty-value">N/A</span>;

  const listForView = compact ? uniqueFirstByTrimmedName(readers) : readers;
  const showExpand = listForView.length > 2;

  return (
    <div className={`projects-table__readers-cell${compact ? ' projects-table__readers-cell--compact' : ''}`}>
      {showExpand ? (
        <>
          <ReadersDataTable readers={listForView.slice(0, 2)} compact={compact} searchHighlightWords={searchHighlightWords} hidePrices={hidePrices} />
          <ExpandableVerticalSlice expanded={expanded}>
            <ReadersDataTable
              readers={listForView.slice(2)}
              compact={compact}
              omitTableHeader={!compact}
              searchHighlightWords={searchHighlightWords}
              hidePrices={hidePrices}
            />
          </ExpandableVerticalSlice>
        </>
      ) : (
        <ReadersDataTable readers={listForView} compact={compact} searchHighlightWords={searchHighlightWords} hidePrices={hidePrices} />
      )}
      {showExpand && (
        <div className="projects-table__readers-expand">
          {expanded ? (
            <button
              type="button"
              className="projects-table__readers-expand-btn"
              onClick={() => setExpanded(false)}
              title="Свернуть"
              aria-label="Свернуть"
            >
              <ExpandLessIcon size={18} />
            </button>
          ) : (
            <button
              type="button"
              className="projects-table__readers-expand-btn"
              onClick={() => setExpanded(true)}
              title="Показать всех"
              aria-label="Показать всех"
            >
              <ExpandMoreIcon size={18} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
